<template>
  <div>
    <hshead title="随便当个链接页" BgColor="#fff"></hshead>
    <div class="router-ul">
      <router-link to="/login">登录注册</router-link>
      <router-link to="/order">下单</router-link>
      <router-link to="/MissionHall">任务大厅</router-link>
      <router-link to="/productList">产品列表</router-link>
      <router-link to="/Trip">我的行程</router-link>
      <router-link to="/other">更多</router-link>
      <router-link to="/center">摄影中心</router-link>
      <router-link to="/city">约拍城市</router-link>
      <router-link to="/income">店铺收益</router-link>
      <router-link to="/orderDetail">订单详情</router-link>
      <router-link to="/applicantCity">申请城市</router-link>
      <router-link to="/photographer">摄影师管理</router-link>
      <router-link to="/shopCustomers">摄影师管理</router-link>
    </div>
  </div>
</template>

<script>
import hshead from "@/components/common/hshead";
export default {
  name: "index",
  data() {
    return{

    }
  },
  components:{
      hshead
  }
};
</script>

<style lang="less" scoped>
.router-ul{
  padding: 0.3rem;
  a{
    font-size: 0.4rem;
    color: blue;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/index.vue